// libs
import { styled } from '@nykaa/ui-components';

// styles
import { BASE_GUTTER_SPACE } from 'shared/styles/base';

export const MenuItemsContainer = styled.div`
  display: flex;
  margin-left: ${BASE_GUTTER_SPACE * 6}px;
  height: 100%;
  width: 100%;
`;
